import { PolygonF, PolygonProps } from '@react-google-maps/api';
import { FC, PropsWithChildren } from 'react';

const POLYGON_OPTIONS: google.maps.PolygonOptions = {
  strokeColor: '#FFFFFF',
  strokeOpacity: 1,
  strokeWeight: 2,
  fillColor: '#000000',
  fillOpacity: 0.2,
};

const Polygon: FC<PropsWithChildren<PolygonProps>> = ({ ...props }) => (
  <PolygonF options={POLYGON_OPTIONS} {...props} />
);
export default Polygon;
